// extracted by mini-css-extract-plugin
module.exports = {"content":"MbapiAdminSection_content__3OoDu","illustration":"MbapiAdminSection_illustration__2bV9D"};